/* eslint-disable */
/**
 * useWindowWidth — returnerer window.innerWidth med resize-listener.
 * Opdateres ved window resize via debounced event.
 *
 * Brug:
 *   const bredde = useWindowWidth();
 *   const isMobil = bredde < 600;
 */

import { useState, useEffect } from 'react';

export default function useWindowWidth() {
  const [bredde, setBredde] = useState(
    typeof window !== 'undefined' ? window.innerWidth : 1200
  );

  useEffect(() => {
    let timeout;
    function handleResize() {
      clearTimeout(timeout);
      // Debounce 80ms — undgår for hyppige re-renders under resize-drag
      timeout = setTimeout(() => {
        setBredde(window.innerWidth);
      }, 80);
    }

    window.addEventListener('resize', handleResize);
    return () => {
      clearTimeout(timeout);
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return bredde;
}
